$(function() {
    $(".header--primary-nav a").on("click", function(e) {
        if($(this).attr("href") == "#") {
            e.stopPropagation();
            return false;
        }
    });
});